

export module Seo{

    export function setTitle(title:string){
        document.title = title
        setOgMetaTag('og:title', title)
    }

    export function setKeywords(keywords:string){
        setSimpleMetaTag('keywords', keywords)
    }

    export function setDescription(description: string){
        setSimpleMetaTag('description', description)
        setOgMetaTag('og:description', description)
    }

    export function setMetaImageTag(imageUrl:string){
        setMetaTag({attributeForName:'itemprop', name:'image', value:imageUrl})
        setMetaTag({attributeForName:'property', name:'og:image', value:imageUrl})
        setMetaTag({attributeForName:'name', name:'twitter:image', value:imageUrl})
    }

    export function setMetaTag(p:{attributeForName:string, attributeForValue?:string, name:string, value:string}){
        if(!p.attributeForValue){
            p.attributeForValue = 'content'
        }
        const tag = document.querySelector(`meta[${p.attributeForName}="${p.name}"]`)
        if(tag){
            tag.setAttribute(p.attributeForValue, p.value)
        } else {
            const newTag = document.createElement('meta')
            newTag.setAttribute(p.attributeForName, p.name)
            newTag.setAttribute(p.attributeForValue, p.value)
            document.getElementsByTagName('head')[0].appendChild(newTag)
        }
    }

    export function setSimpleMetaTag(name:string, value:string){
        const tag = document.querySelector(`meta[name="${name}"]`)
        if(tag){
            tag.setAttribute('content', value)
        } else {
            const newTag = document.createElement('meta')
            newTag.setAttribute('name', name)
            newTag.setAttribute('content', value)
            document.getElementsByTagName('head')[0].appendChild(newTag)
        }
    }

    export function setOgMetaTag(name:string, value:string){
        if(!name.startsWith('og:')) throw new Error('wrong og tag: '+name)
        const tag = document.querySelector(`meta[property="${name}"]`)
        if(tag){
            tag.setAttribute('content', value)
        } else {
            const newTag = document.createElement('meta')
            newTag.setAttribute('property', name)
            newTag.setAttribute('content', value)
            document.getElementsByTagName('head')[0].appendChild(newTag)
        }
    }
}